imagesLoaded = require 'imagesloaded'

class SideBar

  constructor: ->
    @init()

  init: ->
    @state =
      winW       : 0
      winH       : 0
      wrapperH   : 0
      sidebarH   : 0
      headerH    : 0
      fixedPoint : 0
      maxPoint   : 0
      viewTop    : 0
      offset     : 0
      isLock     : false

    @$sidebar        = $('.sidebar')

    if @$sidebar.length == 0
      return

    @$win            = $(window)
    @$body           = $('body')
    @$wrapper        = $('.wrapper')
    @$header         = $('.header')
    @$hotTopics      = $('.hotTopics')
    @$sidebarInner   = $('.sidebar .inner')
    @recommendTemplate = _.template $('#tplSidebarRecommend').html()

    @fetchRecommend()
    @rankingChange()
    @onResize()

    resizeThrottle = _.throttle(@onResize, 100)
    @$win.on 'resize', resizeThrottle
    @$win.on 'scroll', @onScroll

  rankingChange: ->

    _t = @;

    @$rankingTab = @$sidebarInner.find('.sidebar_contents_tab_btn')
    @$rankingList = @$sidebarInner.find('.sidebar_contents_list.rank')

    @$rankingTab.first().addClass('active')
    @$rankingList.last().css
      display: 'none'

    @$rankingTab.on 'click', ->
      if !$(this).hasClass('active')
        activeNum = null
        _t.$rankingTab.removeClass('active')
        $(this).addClass('active')
        activeNum = _t.$rankingTab.index(this)

        _t.$rankingList.css
          display: 'none'
        _t.$rankingList.eq(activeNum).css
          display: 'block'
      return false





  onResize: =>
    @state.winW = @$win.width()
    @state.viewTop = @$win.scrollTop()

    if app.layoutSequencer.getLayout() == 'layout1'

      @state.winH       = @$win.height()
      @state.wrapperH   = @$wrapper.height()
      @state.sidebarH   = @$sidebarInner.height()
      @state.headerH    = @$header.height() + @$hotTopics.height()
      @state.fixedPoint = @state.headerH + (@state.sidebarH - @state.winH)
      @state.maxPoint   = @state.headerH  + (@state.wrapperH - @state.winH)

      if @state.sidebarH > @state.wrapperH
        @state.isLock = true
        @$sidebarInner.css
          position: 'static'
      else
        @state.isLock = false
        @setLayout()

    else
      @$sidebarInner.css
        position: 'static'

    @setMainAreaHeight()


  reflesh: ->
    @onResize()


  onScroll: =>
    @state.viewTop = @$win.scrollTop()
    if app.layoutSequencer.getLayout() == 'layout1'
      if !@state.isLock
        @setLayout()


  setLayout: ->
    if @state.viewTop > @state.maxPoint
      @state.offset = @state.maxPoint - @state.fixedPoint
      @$sidebarInner.css
        position: 'absolute'
        top: ''
        bottom: 0

    else if @state.viewTop > @state.fixedPoint
      @state.offset = @state.viewTop - @state.fixedPoint
      @$sidebarInner.css
        position: 'fixed'
        top: ''
        bottom: 0

    else if @state.viewTop < @state.fixedPoint
      @$sidebarInner.css
        position: 'absolute'
        top: 0
        bottom: ''

  setMainAreaHeight: ->
    if @state.wrapperH < @state.sidebarH
      @$wrapper.css
        'min-height': @state.sidebarH

  fetchRecommend: ->
    options =
      callback: @callbackFetchRecommend

    app.api.getRecommendList options

  callbackFetchRecommend: (data)=>
    recommend = @recommendTemplate
      data: data.result_list

    $('.sidebar_contents_list-reco').html recommend

    imgLoad = imagesLoaded '.sidebar_contents_list-reco'

    # imgLoad.on 'progress', (instance, image )=>
    #   console.log image.img.src

    imgLoad.on 'done', =>
      # console.log 'loaded'
      @reflesh()


module.exports = SideBar



// WEBPACK FOOTER //
// ./src/scripts/modules/SideBar.coffee